import SourceSite from "@/shared/components/SourceSite";
import { webAddress } from "@/shared/lib/sites";
import type { WebSource } from "@/shared/types";

/** Under an answer that cites the web: the sources it cites, as a row of small cards that open
    them (affect-ui's AI Answer), scrolling sideways when they don't fit. */
export default function Sources({ sources }: { sources: WebSource[] }) {
  return (
    <div className="space-y-2 min-w-0">
      <div className="section-label">Sources · <span className="font-mono tabular-nums">{sources.length}</span></div>
      <div className="flex gap-2 overflow-x-auto no-scrollbar min-w-0">
        {sources.map((source) => (
          <a
            key={source.n}
            href={webAddress(source.url)}
            target="_blank"
            rel="noreferrer"
            title={source.url}
            className="press think-chip shrink-0 w-[172px] grid content-start gap-1.5 px-3 pt-2.5 pb-[11px] rounded-[12px] bg-[var(--surface-2)] hover:bg-[var(--surface-3)]"
          >
            <SourceSite source={source} />
            <span className="text-[12.5px] leading-[1.4] text-[var(--text-primary)] line-clamp-2">{source.title}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
